<template>
  <b-modal id="modal-search"
          :dialog-class="'md_modal_dialog_full21 site-detail-width' + (page == 'Map' ? ' left' : '')"
          body-class="md_modal_body_scroll"
          :modal-class="page == 'Map' ? 'md_modal_site_graph' : 'md_modal_full'"
          content-class="md_modal_content_full"
          title="공동주택가격 - 빌라, 아파트"
          header-class="popup_header1"
           :visible="visible"
           @hidden="onCancel();"
           @show="onShow"
           hide-header hide-footer centered>
      <div style="display: flex; flex-direction: column; align-self: center">
        <MdHeaderBar
          :is-custom-back="true"
          @back="onCancel"
          :hide_close="true"
          :hide_like="true"
          :hide_share="true"
          :is_like="false"
          :header_class="'site-detail-width header' + (page == 'Map' ? ' left inquiry' : '')"
          :title="{
            isSingle: false,
            primary: bldnm,
            address: address,
            secondary: '',
          }"
        />
        <div :style="page == 'Map' ? 'padding-top: 0px' : 'padding-top: 90px'">
          <div class="site_header">
            공동주택가격 - 빌라, 아파트
          </div>
          <div class="align-horizontal selected_info" v-if="selectedIdx > -1">
            <div @click="onIdx(-1)" class="page_btn">&lt;&nbsp; </div>
            <div class="align-vertical center">
              <div class="selected_title">
                {{ list[selectedIdx].stdrYear }}년 01월
              </div>
              <div class="selected_title1">
                {{ dongnm == '동명칭 없음' ? '' : (dongnm + (dongnm.endsWith('동')?'':'동')) }} {{ honm + (honm.endsWith('호')?'':'호') }}
              </div>
              <div class="selected_content">
                {{ util.formatNumber(list[selectedIdx].pblntfPc) }}원
              </div>
            </div>
            <div @click="onIdx(1)" class="page_btn">&gt;&nbsp; </div>
          </div>
        </div>
        <div v-if="list.length > 1">
          <LineChart2 :chart-data="list" label="공동주택가격 - 빌라, 아파트" @onClick="onClick"></LineChart2>
        </div>
        <div class="align-vertical paragraph">
          <div class="align-horizontal paragraph_row paragraph_header">
            <div class="paragraph_title">공시기준</div>
            <div class="paragraph_line"></div>
            <div class="paragraph_title">전용면적(㎡)</div>
            <div class="paragraph_line"></div>
            <div class="paragraph_title">공동주택가격</div>
          </div>
          <InquiryItem2 v-for="item in sorted_list"
                    :item="item"
          />
        </div>
      </div>
  </b-modal>
</template>

<script>

import InquiryItem2 from "../InquiryItem2";
import LineChart2 from "../popup/LineChart2";
import MdHeaderBar from "../../controls/MdHeaderBar";
import Utils from "../../../config/utils";

export default {
  name: "GraphPopup2",
  components: {
    InquiryItem2,
    LineChart2,
    MdHeaderBar
  },
  props:["visible", "list", "address", "bldnm", "dongnm", "honm", "page"],
  data() {
    return {
      util: Utils,
      self: this,
      selectedIdx: -1,
    }
  },
  computed: {
    sorted_list() {
      let list = [];
      for (let i = 0; i < this.list.length; i++) {
        list.push(this.list[i])
      }
      list.sort((a, b) => {
        if (a.stdrYear > b.stdrYear) {
          return -1;
        }
        return 1;
      });
      return list;
    }
  },
  methods:{
    onShow() {
      if (this.list.length > 0) {
        this.selectedIdx = this.list.length - 1;
      }
    },
    onCancel()  {
      this.selectedIdx = -1;
      this.$emit('update:visible', false);
    },
    onClick(idx) {
      this.selectedIdx = idx;
    },
    onIdx(offset) {
      if (offset == -1 && this.selectedIdx == 0) return;
      if (offset ==1 && this.selectedIdx == this.list.length - 1) return;
      this.selectedIdx += offset;

      this.eventBus.$emit("draw_line", this.selectedIdx);
    },
  },
  inject: ["eventBus"],
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/Modal.scss";

.paragraph {
  border: 1px solid $c_cacbcd;
  margin-top: 10px;
}
.paragraph_row {
  height: 30px;
}
.paragraph_header {
  background-color: #e8f1f4;
}
.paragraph_top_border {
  border-top: 1px solid $c_cacbcd;
}
.paragraph_line {
  width:1px;
  height:30px;
  background-color:$c_cacbcd;
}
.paragraph_title {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  font-weight: bold;
  color: $black;
  text-align: center;
}
.paragraph_content {
  flex:1;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
  color: $black;
  text-align: center;
}
.site_header{
  margin-bottom: 7px;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.selected_info {
  border-radius: 5px;
  background-color: #e8f1fe;
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
  justify-content: space-between;
}
.center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.page_btn{
  @extend .center;
  width: 25px;
  height: 25px;
  color: #919191;
  font-size: $fs_24;
  font-family: $korean_gd_11_r;
  cursor: pointer;
}
.selected_title {
  color: #313131;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  line-height: 1;
}
.selected_title1 {
  color: #313131;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  text-decoration: underline;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 15px;
}
.selected_content {
  color: $primary;
  font-size: $fs_21;
  font-family: $korean_gd_16_r;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/GraphPopup2.vue